import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
 import { Observable } from 'rxjs/Observable';
//  import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
//  import { catchError, retry } from 'rxjs/operators';
 import 'rxjs/add/operator/map';


//  import { environment } from '../../../../environments/environment';
 import { IContactViewModel,
   INewUserModel,
   ILoginNewUserModel,
   IAuthenticateWith2FARequest,
   IAuthenticateWith2FAResponse,
   IVerifyOtpRequest,
   IResendOtpRequest,
   IResendOtpResponse} from '../../models/accountModel';
 import { DataService } from '../data.service';
@Injectable()
export class AccountService {

  moduleUrl: string;
  userview: IContactViewModel;

  constructor(private _dataService: DataService, private _httpClient: HttpClient) { }

  add(jobPostingModel: IContactViewModel): Observable<INewUserModel> {
    this.moduleUrl = 'account';
    return this._dataService.add(this.moduleUrl, jobPostingModel);
  }

  resetPassword(jobPostingModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'account';
    return this._dataService.UpdateWithoutId(this.moduleUrl, jobPostingModel);
  }

  /** Legacy: POST account/Authenticate. Login uses authenticateWith2FA + verifyOtp; kept for rollback. */
  getUser(contactmodel: IContactViewModel): Observable<any> {
    this.moduleUrl = 'account/Authenticate';
    return this._dataService.add(this.moduleUrl, contactmodel, 0);
  }

  authenticateWith2FA(request: IAuthenticateWith2FARequest): Observable<IAuthenticateWith2FAResponse> {
    this.moduleUrl = 'Account/AuthenticateWith2FA';
    return this._dataService.add(this.moduleUrl, request, 0);
  }

  verifyOtp(request: IVerifyOtpRequest): Observable<any> {
    this.moduleUrl = 'Account/VerifyOtp';
    return this._dataService.add(this.moduleUrl, request, 0);
  }

  resendOtp(request: IResendOtpRequest): Observable<IResendOtpResponse> {
    this.moduleUrl = 'Account/ResendOtp';
    return this._dataService.add(this.moduleUrl, request, 0);
  }

  ChangePassword(contactmodel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'account/ChangePassword';
    return this._dataService.UpdateWithoutId(this.moduleUrl, contactmodel);
  }


  forgotPassword(contactmodel: IContactViewModel, isVisionUser: boolean): Observable<IContactViewModel> {
    this.moduleUrl = 'Account/ForgetPasswordRequest?Email=' + contactmodel.emailId + '' + '&IsVisionUser='+isVisionUser;
    return this._dataService.getSingle(this.moduleUrl, '');
  }

  activeDeactiveUser(contactId: number, isActive: boolean): Observable < any > {
    this.moduleUrl = 'Contact/UpdateActiveStatus?contactId=' + contactId + '&isActive=' + isActive;
    return this._dataService.add(this.moduleUrl, '');
  }
  getVisionRoleList(): Observable<any> {
    this.moduleUrl = 'Master/GetVisionUserRoles';
    return this._dataService.getAll( this.moduleUrl, '');
  }

  setUserRole(userId: string, roleId: string): Observable < any > {
    this.moduleUrl = 'Account/SetVisionUserRole?userId=' + userId + '&roleId=' + roleId;
    return this._dataService.add(this.moduleUrl, '');
  }

  updateTestAccount(contactId: number,companyId:number, isTestAccount: boolean): Observable < any > {
    this.moduleUrl = 'Contact/UpdateTestAccount?contactId=' + contactId + '&companyId='+companyId + '&isTestAccount=' + isTestAccount;
    return this._dataService.add(this.moduleUrl, '');
  }

  updateNetworkSupplierSetting(companyId: number, isNetworkRfqEnabled: boolean): Observable<any> {
    this.moduleUrl = 'Account/UpdateNetworkSupplierSetting';
    return this._dataService.UpdateWithoutId(this.moduleUrl, {
      companyId,
      isNetworkRfqEnabled
    });
  }
  ChangeSupplierAccountStatus(contactId: number, companyId:number, isEnabled: boolean): Observable < any > {
    this.moduleUrl = 'ProfileManagement/ChangeSupplierAccountStatus?contactId=' + contactId + '&companyId='+companyId + '&isEnabled=' + isEnabled;
    return this._dataService.getAll(this.moduleUrl, '');
  }

//   public authenticateUser<userview>(userViewModel: IContactViewModel): Observable<IContactViewModel> {
//     return this._httpClient
//         .get('http://18.217.134.136:82/api/Account/Authenticate??Email=' + userViewModel.emailId +
// '&Password=' + userViewModel.password);

// }


}



// WEBPACK FOOTER //
// ./src/app/core/services/account/account.service.ts